import { useMemo, useState } from 'react'
import * as ResumoHttp from '../../../../../services/api/https/picking/resumo-separcao.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_SOBRAS: 'Salvando sobras',
  SAVE_SOBRAS_SUCCESS: 'Sobras salvas com sucesso',
  FILE_UPLOADED: 'Foto anexada',
}

const INITIAL_STATE = {
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  globalFilter: '',
  produtos: [],
  btnSalvarDisabled: false,
  btnLoading: false,
  modal: { show: false, data: {} },
  itemSelected: {},
}

export default function useSobrasManual() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      saveSobrasSeparacaoManual(produtos, picking_id) {
        const sobras = produtos
          .filter(p => p.qte_leftover > 0)
          .map(pp => {
            const { product_id, qte_leftover, files } = pp
            let saveFiles = []
            if (files.length && typeof files[0] !== 'string') {
              saveFiles = files.map(f => f.url_image)
            } else saveFiles = files
            if (pp.missing_reason !== '')
              return {
                picking_id,
                product_id,
                qte_leftover: Number(qte_leftover),
                missing_reason_id: pp.missing_reason.id,
                files: saveFiles,
              }
            return {
              picking_id,
              product_id,
              qte_leftover: Number(qte_leftover),
              files: saveFiles,
            }
          })

        ResumoHttp.saveSobrasSeparacaoManual(sobras, picking_id)
          .then(res => {
            const aggruped = (Array.isArray(res) ? res : []).reduce((acc, curr) => {
              if (!acc[curr.product_id]) acc[curr.product_id] = []
              acc[curr.product_id].push({ url_image: curr.url_image, id: curr.id })
              return acc
            }, {})

            setState(prevState => {
              Object.keys(aggruped).forEach(key => {
                const index = prevState.produtos.findIndex(p => p.product_code === key)

                if (index !== -1) {
                  prevState.produtos[index].files = aggruped[key]
                }
              })
              return {
                ...prevState,

                loadingMessage: LOAD_MESSAGE.SAVE_SOBRAS_SUCCESS,
              }
            })
          })
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      //Events
      onInit(leftover_products) {
        setState(prevState => ({ ...prevState, produtos: leftover_products }))
      },

      onSobraInputChange(produto, qte_leftover) {
        const { product_code } = produto
        setState(prevState => {
          const { produtos } = prevState
          const index = produtos.findIndex(p => p.product_code === product_code)
          if (index !== -1) {
            produtos[index].qte_leftover =
              qte_leftover === '' || qte_leftover === 0 ? '' : qte_leftover
          }
          return { ...prevState, produtos: produtos }
        })
      },

      onBtnSalvarClicked(status) {
        if (status === 'Resumo Emitido')
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Alteração não Permitida. Resumo já Emitido',
          }))
        else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_SOBRAS }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onDropdownChange(sobra, ocorrencia) {
        setState(prevState => {
          const index = prevState.produtos.findIndex(p => p.product_code === sobra.product_code)
          if (index !== -1) {
            prevState.produtos[index].missing_reason = ocorrencia
          }
          return { ...prevState }
        })
      },

      onVerFotosClicked(leftover_product) {
        setState(prevState => ({
          ...prevState,
          modal: { show: true, data: { fotos: leftover_product.files } },
          itemSelected: leftover_product,
        }))
      },

      onUploadCompleted(file_names, item) {
        setState(prevState => {
          const index = prevState.produtos.findIndex(p => p.product_id === item.product_id)
          if (index !== -1) {
            prevState.produtos[index].files = [
              ...prevState.produtos[index].files.map(f => f.url_image),
              ...JSON.parse(file_names),
            ]
          }
          prevState.loadingMessage = LOAD_MESSAGE.FILE_UPLOADED

          return { ...prevState }
        })
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: {} } }))
      },

      async onDeleteFoto(foto, selectedPicking) {
        try {
          await Promise.all([
            ResumoHttp.deleteLeftOverImage(selectedPicking.id, foto.id),
            ResumoHttp.deleteLeftOverFile(foto.url_image),
          ])

          setState(prevState => {
            const index = prevState.produtos.findIndex(
              i => i.product_id === prevState.itemSelected.product_id,
            )
            if (index !== -1) {
              prevState.produtos[index].files = prevState.produtos[index].files.filter(
                f => f.id !== foto.id,
              )
            }
            return { ...prevState }
          })
        } catch (error) {
          setState(prevState => ({ ...prevState, errorMessage: error.message }))
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
